import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';

interface Point {x: number; y: number; }
interface Boundaries {left: number; right: number;  top: number;  bottom: number; }

@Component({
  selector:    'app-modal-change-profilpic',
  templateUrl: './modal-change-profilpic.component.html',
})
export class ModalChangeProfilpicComponent extends ExcTranslation implements AfterViewInit {

  @ViewChild('pictureCanvas') picCanvas!: ElementRef<HTMLCanvasElement>;

  @Input() data: any;
  @Input() img: HTMLImageElement = new Image();
  @Input() canvasWidth = 570;
  @Input() canvasHeight = 400;
  @Input() outputImageWidth  = 128;
  @Input() outputImageHeight = 128;
  // @Input() exgModalService!: ExgModalService;

  @Output() imgChange = new EventEmitter<HTMLImageElement>();

  context!: CanvasRenderingContext2D;
  private canvas!: HTMLCanvasElement;
  private userClicked = false;
  private oldMousePoint: Point = { x: 0, y: 0 };
  private imageSize = {
    width: this.canvasWidth / 2
    , height: this.canvasHeight / 2
    , start: {
      x: this.canvasWidth / 4
      , y: this.canvasHeight / 4 }
  };
  private halfSmallerImageSideSize: number = this.imageSize.height < this.imageSize.width ?
    this.imageSize.height / 2 : this.imageSize.width / 2;
  private mid: Point = {
    x: this.canvasWidth / 2
    , y: this.canvasHeight / 2 };
  public zoom = {
    max: 10
    , min: 0
    , factor: 5 / 4
    , scaleValue: 0
    , current: 1
    , step: .1};
  constructor(public exgModalService: ExgModalService) {
    super();
  }
  ngAfterViewInit(): void {
    this.img.src  = this.data;
    this.canvas = this.picCanvas.nativeElement;
    // @ts-ignore
    this.context = this.canvas.getContext('2d');
    this.canvas.width = this.canvasWidth;
    this.canvas.height = this.canvasHeight;
    this.img.onload = (ev) => {
      // rebuild startparameters
      // zoomfactor = 1
      this.zoom.current = 1.;
      this.zoom.scaleValue = 0;
      this.scrollhelper(1 / this.zoom.current);
      // translate to middlepoint
      this.context.translate((this.mid.x - this.canvasWidth / 2), this.mid.y - this.canvasHeight / 2);
      this.mid = { x: this.canvasWidth / 2, y: this.canvasHeight / 2 };
      // draw (new) image to canvas
      this.picIntoCanvasRatio();
      this.redraw();
    };
    this.imgChange.emit(this.img);
    this.openfile();
  }
  private picIntoCanvasRatio(): void {
    const wrh = this.img.naturalWidth / this.img.naturalHeight;
    this.imageSize.width = this.canvasWidth;
    this.imageSize.height = Math.floor(this.imageSize.width / wrh);
    this.imageSize.start.y = Math.floor((this.canvasHeight - this.imageSize.height) / 2);
    this.imageSize.start.x = 0;
    if (this.imageSize.height > this.canvasHeight) {
      this.imageSize.height = this.canvasHeight;
      this.imageSize.width = Math.floor(this.imageSize.height * wrh);
      this.imageSize.start.x = Math.floor((this.canvasWidth - this.imageSize.width) / 2);
      this.imageSize.start.y = 0;
    }
    this.halfSmallerImageSideSize = this.imageSize.height < this.imageSize.width ? this.imageSize.height / 2 : this.imageSize.width / 2;
  }

  public setClickedBoolAndCoords(set: boolean, event: MouseEvent | TouchEvent): void {
    this.userClicked = set;
    if ('pageX' in event && event.pageX && event.pageY) {
      this.oldMousePoint.x = event.pageX;
      this.oldMousePoint.y = event.pageY;
    }else if ('changedTouches' in event && event.changedTouches[0].pageX && event.changedTouches[0].pageY){
      this.oldMousePoint.x = event.changedTouches[0].pageX;
      this.oldMousePoint.y = event.changedTouches[0].pageY;
    }
  }
  handleMoveEvent(event: MouseEvent | TouchEvent): void {
    if (!this.userClicked) {
      return;
    }
    if ('pageX' in event && event.pageX && event.pageY) {
      const position: Point = { x: event.pageX, y: event.pageY};
      this.movePicture(position);
    }else if ('changedTouches' in event && event.changedTouches[0].pageX && event.changedTouches[0].pageY){
      const position: Point = { x: event.changedTouches[0].pageX, y: event.changedTouches[0].pageY};
      this.movePicture(position);
    }
  }

  private movePicture(point: Point): void {
    let dp: Point = {x: point.x - this.oldMousePoint.x, y: point.y - this.oldMousePoint.y};
    this.oldMousePoint.x = point.x;
    this.oldMousePoint.y = point.y;
    const check: Point = {x: this.mid.x - dp.x, y: this.mid.y - dp.y};
    const boundaries: Boundaries = {
      left: this.halfSmallerImageSideSize + this.imageSize.start.x,
      right: this.imageSize.start.x + this.imageSize.width - this.halfSmallerImageSideSize,
      top: this.halfSmallerImageSideSize + this.imageSize.start.y,
      bottom: this.imageSize.start.y + this.imageSize.height - this.halfSmallerImageSideSize
    };
    const elseCase: Boundaries = {
      left: 0, right: 0, top: 0, bottom: 0
    };

    dp = this.BounderyCheck(dp, boundaries, check, elseCase);
    this.mid.x -= dp.x;
    this.mid.y -= dp.y;
    this.context.translate(dp.x, dp.y);
    this.redraw();
  }

  onScrollScale(event: string): void {
    const tmp = parseFloat(event);
    const pow = tmp - Math.round(10 * Math.log(this.zoom.current) / Math.log(this.zoom.factor)) / 10;
    const zoom = Math.pow(this.zoom.factor, pow);
    this.zoom.current *= zoom;
    this.zoom.scaleValue = tmp;
    this.scrollhelper(zoom);
    this.redraw();
  }
  /**
   * Nebenbedingung zoom factor zoom_in / zoom_out = 1
   */
  onScrollCanvas(event: Event): void {
    event.preventDefault();
    const wheel: WheelEvent = (event as WheelEvent);
    let zoom = Math.pow(this.zoom.factor, wheel.deltaY > 0 ? 1 : -1);
    this.zoom.current *= zoom;
    // max || min zoom
    if (this.zoom.current > Math.pow(this.zoom.factor, this.zoom.max)
      || this.zoom.current < Math.pow(this.zoom.factor, this.zoom.min)) {
      const tmp = this.zoom.current / zoom;
      const current = Math.pow(this.zoom.factor, this.zoom.current < Math.pow(this.zoom.factor, this.zoom.min) ?
        this.zoom.min : this.zoom.max);
      zoom = current / tmp;
      this.zoom.current = current;
    }
    this.zoom.scaleValue = this.zoom.max * Math.log(this.zoom.current) / Math.log(Math.pow(this.zoom.factor, this.zoom.max));
    this.scrollhelper(zoom);
    this.redraw();
  }
  private scrollhelper(zoom: number): void {
    // if everyting is in the pictures
    const movement = {
      x: this.canvasWidth * (zoom - 1) / 2
      , y: this.canvasHeight * (zoom - 1) / 2 };
    const toCheck: Point = {
      x: (this.mid.x + movement.x) / zoom
      , y: (this.mid.y + movement.y) / zoom };
    let delta: Point = { x: 0, y: 0 };
    this.halfSmallerImageSideSize /= zoom;
    this.halfSmallerImageSideSize = Math.round(this.halfSmallerImageSideSize * 100) / 100;
    const boundaries: Boundaries = {
      left: this.halfSmallerImageSideSize + this.imageSize.start.x,
      right: this.imageSize.start.x + this.imageSize.width - this.halfSmallerImageSideSize,
      top: this.halfSmallerImageSideSize + this.imageSize.start.y,
      bottom: this.imageSize.start.y + this.imageSize.height - this.halfSmallerImageSideSize
    };
    const elseCases: Boundaries = {
      left: boundaries.left - toCheck.x,
      right: boundaries.right - toCheck.x,
      top: boundaries.top - toCheck.y,
      bottom: boundaries.bottom - toCheck.y
    };
    delta = this.BounderyCheck(delta, boundaries, toCheck, elseCases);
    this.mid.x = (this.mid.x + movement.x) / zoom + delta.x;
    this.mid.y = (this.mid.y + movement.y) / zoom + delta.y;
    this.context.translate(- movement.x - delta.x * zoom, -movement.y - delta.y * zoom);
    this.context.scale(zoom, zoom);
  }

  private BounderyCheck(delta: Point, bounds: Boundaries, toCheck: Point, elsecase: Boundaries): Point {
    delta.x = toCheck.x < bounds.left ? elsecase.left : delta.x;
    delta.x = toCheck.x > bounds.right ? elsecase.right : delta.x;
    delta.y = toCheck.y < bounds.top ? elsecase.top : delta.y;
    delta.y = toCheck.y > bounds.bottom ? elsecase.bottom : delta.y;
    return delta;
  }

  save(): void {
    const rescaledRadius = this.halfSmallerImageSideSize * this.zoom.current;
    const diameter = 2 * rescaledRadius;
    this.clear();
    this.drawImg();
    const imgdata = this.context.getImageData(
      this.canvasWidth / 2 - rescaledRadius
      , (this.canvasHeight / 2) - rescaledRadius, diameter, diameter);
    this.drawCircle();
    const newcanvas = document.createElement('canvas') as HTMLCanvasElement;
    newcanvas.height = this.outputImageHeight;
    newcanvas.width = this.outputImageWidth;
    createImageBitmap(imgdata)
      .then((v: any) => {
        // @ts-ignore
        newcanvas.getContext('2d').drawImage(v, 0, 0, this.outputImageWidth, this.outputImageHeight);
        this.exgModalService.action({ img: newcanvas.toDataURL() });
      });
  }

  private redraw(): void {
    this.clear();
    this.drawImg();
    this.drawCircle();
  }
  private clear(): void {
    this.context.clearRect(-1 * this.canvasWidth, -1 * this.canvasHeight, 3 * this.canvasWidth, 3 * this.canvasHeight);
  }
  private drawImg(): void {
    this.context.globalAlpha = 1;
    this.context.drawImage(this.img, this.imageSize.start.x, this.imageSize.start.y, this.imageSize.width, this.imageSize.height);
  }
  private drawCircle(): void {
    this.context.globalAlpha = 0.25;
    this.context.beginPath();
    this.context.arc(this.mid.x, this.mid.y, this.halfSmallerImageSideSize, 0, 2 * Math.PI);
    this.context.rect(-this.canvasWidth, 2 * this.canvasHeight, 3 * this.canvasWidth, -3 * this.canvasHeight);
    this.context.fill();
    this.context.globalAlpha = 1;
    this.context.beginPath();
    this.context.arc(this.mid.x, this.mid.y, this.halfSmallerImageSideSize - 2.5 / this.zoom.current, 0, 2 * Math.PI);
    this.context.lineWidth = 5 / this.zoom.current;
    this.context.strokeStyle = 'white';
    this.context.stroke();
  }
  public cancel(): void {
    this.exgModalService.close();
  }
  onFileChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    const file: File = files[0];
    target.value = '';
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.img.src = fileReader.result as string;
    };
    fileReader.readAsDataURL(file);
  }
  openfile(): void {
    const e: HTMLElement = document.getElementById('uploadInput') as HTMLElement;
    e.click();
  }
}
